import { axiosGet, axiosPost } from '@/api/AxiosApi';
// 약관 타입
// tt01: 서비스이용약관
// tt02: 전자금융거래약관
// tt03: 전자상거래약관
// tt04: 개인정보처리방침
// tt05: 마케팅 정보 수신 동의
// tt06: 개인정보 수집 및 이용 동의
export type termsTypeProps = 'tt01' | 'tt02' | 'tt03' | 'tt04' | 'tt05' | 'tt06';

// 약관 목록 조회 액션
export type resTermListProps = {
  terms_id: string;
  seq: number;
  terms_type: string;
  terms_ver: string;
  title: string;
  post: any;
};
export const termsList = async () => {
  const payload = {
    path: '/v1/users/terms',
    body: {
      require_yn: '',
      lang: 'KO',
    },
  };
  const { data: re } = await axiosPost(payload);
  return re;
};

// 링크로 조회 가능
type termDetailProps = {
  terms_id: string;
};
// 약관 내용 조회
export const termDetail = async ({ terms_id }: termDetailProps) => {
  const payload = {
    path: `/v1/users/terms/${terms_id}`,
  };
  const { data: re } = await axiosGet(payload);
  return re;
};

type previousTermListProps = {
  lang: 'KO' | 'EN';
  terms_type: termsTypeProps;
};
export type resPreviousTermListProps = {
  end_dt: string | null;
  lang: string;
  mod_dt: string;
  reg_dt: string;
  require_yn: string;
  seq: number;
  sort_no: string;
  start_no: string;
  terms_id: string;
  terms_type: string;
  terms_ver: string;
  title: string;
  use_yn: string;
};
export const previousTermList = async ({ lang = 'KO', terms_type }: previousTermListProps) => {
  const paylaod = {
    path: '/v1/board/terms/list',
    body: { list_size: 100, page_num: 1, lang, terms_type },
  };
  const { data: re } = await axiosPost(paylaod);
  return re;
};
